export default "__VITE_PUBLIC_ASSET__b5beb765__"